var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle",class:{active: _vm.isActive}},[_c('a',{attrs:{"href":"#0"},on:{"click":function($event){$event.preventDefault();return _vm.update($event)}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12aff986","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/ToggleFilter.vue
// module id = 470
// module chunks = 0